import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppError } from '@app/core/message/models/error.model'

@Component({
    selector: 'aio-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.sass'],
    standalone: false
})
export class ErrorDialogComponent {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    public dialogRef: MatDialogRef<ErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { error: AppError; header: string }
  ) {}
}
